module.exports = __webpack_public_path__ + "static/media/1_07.7b57ae9d.jpg";